import axios from './axios'

export const createTimesheetAdjustment = ({ data }) => axios.post('timesheet_adjustments', data)
export const deleteTimesheetAdjustment = ({ id }) => axios.delete(`timesheet_adjustments/${id}`)
export const findTimesheetAdjustment = ({ id, params } = {}) => axios.get(`timesheet_adjustments/${id}`, { params })
export const getTimesheetAdjustments = ({ params } = {}) => axios.get('timesheet_adjustments', { params })
export const updateTimesheetAdjustment = ({ id, data }) => axios.put(`timesheet_adjustments/${id}`, data)
